module.exports = __webpack_public_path__ + "static/img/goback.e9dde1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/goback.png
// module id = 161
// module chunks = 17 18